import React from 'react';
import './styles/Layout.scss';

const Layout = (props) => {

  return (
    
    <div className="layout">
      <div className="Round"></div>
      <div></div>
      <div className="images-container">
        <img className="img2" src="/images/r2c.png"/>
      </div>
      <table width="640" cellSpacing="0" cellPadding="0" border="0" align="center" style={{ margin: '8px auto 15px auto' }}>
        <tbody>
          <tr>
            
          </tr>
        </tbody>
      </table>
      
      

      {props.children}

      
      
      
      
    </div>
  )
};

export default Layout;